// extracted by mini-css-extract-plugin
export default {"info":"EditUserPage_info__L4EQb"};